import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/sx-layout/common/Button";
import { getRotatedRectBoundingBox, isNearCardinal } from "@/sx-layout/components/plotmap/util/coords";
import { useFloatingBottomPosition } from "@/sx-layout/components/settings/plotPlanMapping/hooks/useFloatingBottomPosition";
import { MapState } from "@/sx-layout/hooks/useMapState";

type Props = {
  mapState: MapState;
  rect: {
    top: number;
    left: number;
    width: number;
    height: number;
    rotation?: number;
  };
  onClick: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

export const PlotPlanDetailDisplayButton: FC<Props> = ({ mapState, rect, onClick }) => {
  const { t } = useTranslation();
  const { scale } = mapState;

  const boundingBox = useMemo(() => {
    return getRotatedRectBoundingBox(rect.left, rect.top, rect.width, rect.height, rect.rotation ?? 0);
  }, [rect.left, rect.top, rect.width, rect.height, rect.rotation]);

  const margin = useMemo(() => (isNearCardinal(rect.rotation ?? 0) ? 20 : 0), [rect.rotation]);

  const { top, left, transformOrigin } = useFloatingBottomPosition(
    boundingBox,
    mapState,
    { width: 100, height: 36 },
    margin
  );

  return (
    <div
      className="absolute z-10"
      style={{
        transform: `scale(${scale})`,
        transformOrigin: transformOrigin,
        left,
        top,
      }}
    >
      <Button
        className="bg-[#dea321] text-white border-[2px] border-solid border-white rounded-[5px]"
        onClick={onClick}
      >
        {t("display_switch")}
      </Button>
    </div>
  );
};
